/*@flow*/
import { type ContextRouter } from 'react-router-dom';

export const updateScrollPosition = (anchor: string) => {
  const node = document.querySelector(`#${anchor}`);

  if (node && document.body && node.parentNode) {
    // $FlowFixMe
    if (!node.parentNode.classList.contains('Cell')) {
      if (process.env.__DEV__) {
        throw new Error('Parent of CellHeader must be Cell.');
      }
    }

    const parent = node.parentNode;

    // $FlowFixMe
    const newPos = Math.max(0, parent.offsetTop - 40);
    let timer = setInterval(() => {
      // $FlowFixMe
      if (newPos !== document.body.scrollTop) {
        // $FlowFixMe
        document.body.scrollTop = newPos;
      } else {
        clearInterval(timer);
      }
    }, 5);

    setTimeout(() => clearInterval(timer), 2000);
  }
};

export default (props: ContextRouter) => {
  const t = props.location.query && props.location.query.t;
  if (t) {
    updateScrollPosition(t);
  }
};
